module.exports = __webpack_public_path__ + "static/media/graylinxlogo2.1ad063c6.png";